import React from "react";
import { Briefcase } from "lucide-react";
import { fmtIDR } from "../../lib/api";
import { fmtQty, perLabel } from "./shared";

export default function ChatJobInfo({ ctx }) {
  if (!ctx) return null;
  return (
    <div data-testid="chat-job-info" className="px-4 py-2.5 border-b border-[#35353B] bg-[#D4AF37]/5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
      <span className="flex items-center gap-1.5 font-bold text-[#D4AF37] font-mono"><Briefcase size={13} /> {ctx.job_no}</span>
      <span className="text-[#F5F3ED]">{ctx.game_name} · {ctx.server_name}{ctx.faction ? ` · ${ctx.faction}` : ""}</span>
      <span className="text-[#A8A8AD]">{ctx.item_name}</span>
      {ctx.quantity != null && <span className="text-[#F5F3ED]">Alokasi {ctx.alloc_no}: <b>{fmtQty(ctx.quantity)}</b></span>}
      <span className="text-[#A8A8AD]">Harga {fmtIDR(ctx.price_per_unit_idr)}{perLabel(ctx.price_per_qty)}</span>
      {ctx.total_idr != null && <span className="text-[#D4AF37] font-bold">Kesepakatan {fmtIDR(ctx.total_idr)}</span>}
    </div>
  );
}
